import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { NotesEffects } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.effects';
import { notesReducer } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.reducers';
import { notesFeatureKey } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.selectors';
import { EnvironmentProviders } from '@angular/core';

export const provideNotesStore = (): EnvironmentProviders[] => [
    provideState(notesFeatureKey, notesReducer),
    provideEffects(NotesEffects)
];
